// components/CheckoutCompletionHandler.tsx

"use client";

import { useEffect } from 'react';
import { useCart } from '@/context/CartContext';
import { tracking } from '@/lib/tracking';

// 체크아웃 완료 추적 sessionStorage 키
const TRACKED_KEY_PREFIX = 'tracked_checkout_';

const CheckoutCompletionHandler: React.FC = () => {
  const { clearCart } = useCart();

  useEffect(() => {
    // URL 파라미터에서 체크아웃 완료 확인
    const urlParams = new URLSearchParams(window.location.search);
    const checkoutComplete = urlParams.get('checkout_complete');

    if (checkoutComplete !== 'true') return;

    // 세션 스토리지에서 체크아웃 시작 플래그 확인
    const checkoutTimestamp = sessionStorage.getItem('checkoutTimestamp');

    console.log('Checkout completion detected, clearing cart and resetting flags');

    // 중복 fire 방지: 동일 타임스탬프로 이미 추적된 경우 스킵
    const trackedKey = TRACKED_KEY_PREFIX + (checkoutTimestamp || 'unknown');
    const alreadyTracked = sessionStorage.getItem(trackedKey);

    if (!alreadyTracked) {
      // 체크아웃 완료 추적 이벤트 전송
      const cartTotal = parseFloat(sessionStorage.getItem('checkoutCartTotal') || '0');
      const itemCount = parseInt(sessionStorage.getItem('checkoutItemCount') || '0', 10);
      // Shopify 홈으로 리다이렉트 방식이므로 orderId 없음 — 타임스탬프를 임시 식별자로 사용
      const pseudoOrderId = checkoutTimestamp || String(Date.now());
      tracking.checkoutComplete(pseudoOrderId, cartTotal, itemCount);

      // 중복 fire 방지 플래그 설정 (세션 내 유효)
      sessionStorage.setItem(trackedKey, '1');
    }

    // 카트 비우기
    clearCart();

    // 체크아웃 관련 플래그들 정리
    sessionStorage.removeItem('checkoutStarted');
    sessionStorage.removeItem('checkoutTimestamp');
    sessionStorage.removeItem('checkoutCartTotal');
    sessionStorage.removeItem('checkoutItemCount');

    // 카트 초기화 플래그 제거 (다음 카트 방문 시 다시 초기화되도록)
    sessionStorage.removeItem('cartInitialized');
    sessionStorage.removeItem('cartInitializationComplete');

    // URL에서 체크아웃 완료 파라미터 제거
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('checkout_complete');
    window.history.replaceState({}, '', newUrl.toString());
  }, [clearCart]);

  // 이 컴포넌트는 UI를 렌더링하지 않음
  return null;
};

export default CheckoutCompletionHandler;
